import '@/utils/babel-import'
import Vue from 'vue'
import i18n from '@/i18n'
import loaderFull from '@/components/base/loader/base-full-loader-plugin'
import baseFullLoader from '@/components/base/base-full-loader'
require('@/assets/styles/main.scss')
require('@/config/axios')

Vue.config.productionTip = false

Vue.use(loaderFull)

Vue.component('base-full-loader', baseFullLoader)

if (document.getElementById('hc-vue-tv-channels')) {
  const requireComponent = require.context('./views/', false, /view-[^\\]*\.vue$/)
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName)
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1') // TODO Normalize component names
    Vue.component(componentName, componentConfig.default || componentConfig)
  })

  new Vue({
    i18n,
    el: '#hc-vue-tv-channels'
  }).$mount('#hc-vue-tv-channels')
}
